import { render, staticRenderFns } from "./CommunityTable.vue?vue&type=template&id=516245b6"
import script from "./CommunityTable.vue?vue&type=script&lang=js"
export * from "./CommunityTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports